import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { MessagesService } from '../classes/message-service';
import { SystemNotificationType } from './system-notification-type.enum';
import { SystemNotificationMessage } from './system-notification-message.model';

@Injectable({ providedIn: 'root' })
export class SystemNotificationsService extends MessagesService<SystemNotificationMessage> {
  private createNotification(type: SystemNotificationType, message: string, timeout?: number): void {
    this.queue({ uId: uuid(), type, message, timeout });
  }

  info(message: string, timeout = 0): void {
    this.createNotification(SystemNotificationType.Info, message, timeout);
  }

  success(message: string, timeout = 7000): void {
    this.createNotification(SystemNotificationType.Success, message, timeout);
  }

  warning(message: string, timeout = 0): void {
    this.createNotification(SystemNotificationType.Warning, message, timeout);
  }

  error(message: string, timeout = 0): void {
    this.createNotification(SystemNotificationType.Error, message, timeout);
  }
}
